module.exports = __webpack_public_path__ + "55536c8e9e9a532651e3cf374f290ea3.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/typeface-roboto/files/roboto-latin-300.woff2
// module id = 659
// module chunks = 0